import { render } from "./pageHeader.vue?vue&type=template&id=12d46d03&ts=true"
import script from "./pageHeader.vue?vue&type=script&lang=ts"
export * from "./pageHeader.vue?vue&type=script&lang=ts"

import "./pageHeader.vue?vue&type=style&index=0&id=12d46d03&lang=scss"

import exportComponent from "/home/ssh/jigoucode/jigou_fe_v5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__